import { desktopBreakpoint } from 'react-components'
import styled, { css } from 'styled-components'

import ExternalLink from '../../../common/external-link'
import { ChevronRightIcon } from '../../../common/icons'

export const MenuItemContainer = styled.li``

export const MenuItemContent = styled(ExternalLink)(
    ({ theme }) => css`
        display: flex;
        padding: ${theme.spacing.medium};
        align-items: center;
        text-decoration: none;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            &:hover {
                background-color: ${theme.colors.tfwBlack12};
            }
        }
    `,
)

export const MenuItemIcon = styled.svg.attrs({ width: '24px', height: '24px' })(
    ({ theme }) => css`
        min-width: ${theme.layout.xSmall};
        min-height: ${theme.layout.xSmall};
    `,
)

export const MenuItemText = styled.span(
    ({ theme }) => css`
        font-size: ${theme.typography.font.size.medium};
        line-height: ${theme.typography.font.size.xLarge};
        color: ${theme.colors.tfwBlack87};
        margin: 0 ${theme.spacing.medium};
        flex-grow: 1;
    `,
)

export const GoToMenuItemLinkIcon = styled(ChevronRightIcon)(
    ({ theme }) => css`
        min-width: ${theme.layout.xSmall};
        min-height: ${theme.layout.xSmall};

        path {
            stroke-width: ${theme.typography.border.width.xxxThin};
        }
    `,
)
